import LoginPage from "views/Pages/LoginPage.jsx";

// @material-ui/icons
import Fingerprint from "@material-ui/icons/Fingerprint";

const pagesRoutes = [
  {
    path: "/login",
    name: "Login Page",
    short: "Login",
    mini: "RP",
    icon: Fingerprint,
    component: LoginPage
  },
];

export default pagesRoutes;



// WEBPACK FOOTER //
// ./src/routes/pages.jsx